// extracted by mini-css-extract-plugin
module.exports = {"preview__types":"Channels_preview__types__243lg","unauthorized":"Channels_unauthorized__3_zU9"};